import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ReviewerInteraction } from '@sleipai/sleip-models';
import * as ReviewerInteractionActions from '../actions/reviewer-interaction.actions';

export const reviewerInteractionFeatureKey = 'reviewerInteraction';

export interface State extends EntityState<ReviewerInteraction> {
  loaded: boolean;
  loading: boolean;
}

export function selectById(r: ReviewerInteraction) {
  return r.recordingId
}

export function sortById(a: ReviewerInteraction, b: ReviewerInteraction) {
  return a.recordingId.localeCompare(b.recordingId);
}

export const adapter: EntityAdapter<ReviewerInteraction> = createEntityAdapter<ReviewerInteraction>({
  selectId: selectById,
  sortComparer: sortById
})

export const initialState: State = adapter.getInitialState({
  loaded: false,
  loading: false,
});

export const reducer = createReducer(
  initialState,
  on(ReviewerInteractionActions.loadReviewerInteractions, state => state),
  on(ReviewerInteractionActions.loadReviewInteractionById, state => {
    return {
      ...state,
      loading: true
    }
  }),
  on(ReviewerInteractionActions.addSingleReviewInteraction, (state, { reviewActions }) => {
    return adapter.upsertOne(reviewActions, state)
  }),
  on(ReviewerInteractionActions.updateSingleReviewInteraction, (state, { update }) => {
    return adapter.upsertOne(update, state)
  })

);
